{
  "version": "1.0",
  "chart": "horizontal-bar",
  "// about": "Self-contained config for the (legacy) Horizontal Bar Chart layout — the formula-driven single-value bar, distinct from the unified bar-column family. Deep-merged into the shell via `chartConfigs`. Owns only its builder steps; it reuses shared option lists.",

  "layoutSteps": {
    "HORIZONTAL_BAR_CHART": {
      "label": "Horizontal bar chart",
      "sections": [
        {
          "id": "config",
          "title": "Chart configuration",
          "hint": "Pick the layout, name the chart, and choose one dataset.",
          "fields": [
            { "field": "layoutType", "label": "Chart layout", "control": "select", "optionsKey": "layoutTypes", "required": true },
            { "field": "title", "label": "Title", "control": "text", "required": true },
            { "field": "dataset", "label": "Dataset", "control": "select", "required": true }
          ]
        },
        {
          "id": "axes",
          "title": "Bar axes",
          "hint": "One group-by field on the Y-axis and one formula-driven value on the X-axis.",
          "fields": [
            { "field": "groupByField", "label": "Y-axis — group by", "control": "select", "required": true },
            { "field": "groupByLabel", "label": "Y-axis display name", "control": "text" },
            { "field": "valueLabel", "label": "X-axis value label", "control": "text" },
            { "field": "valueFormula", "label": "X-axis value formula", "control": "text", "required": true }
          ]
        }
      ]
    }
  },

  "options": {
    "// formatControls": "Per-tile Format-popup controls for this layout only (appliesTo HORIZONTAL_BAR_CHART); the shared controls from the shell still apply. X = the value axis, Y = the group-by (category) axis.",
    "formatControls": [
      { "key": "xAxisPrefix", "label": "X-axis prefix", "placeholder": "e.g. $", "width": "half", "control": "text", "default": "", "enabled": true, "group": "Formatting", "appliesTo": ["HORIZONTAL_BAR_CHART"] },
      { "key": "xAxisSuffix", "label": "X-axis suffix", "placeholder": "e.g. %", "width": "half", "control": "text", "default": "", "enabled": true, "group": "Formatting", "appliesTo": ["HORIZONTAL_BAR_CHART"] },
      { "key": "yAxisPrefix", "label": "Y-axis prefix", "placeholder": "e.g. $", "width": "half", "control": "text", "default": "", "enabled": true, "group": "Formatting", "appliesTo": ["HORIZONTAL_BAR_CHART"] },
      { "key": "yAxisSuffix", "label": "Y-axis suffix", "placeholder": "e.g. %", "width": "half", "control": "text", "default": "", "enabled": true, "group": "Formatting", "appliesTo": ["HORIZONTAL_BAR_CHART"] }
    ]
  }
}
